export const API_URL = process.env.API_URL;
export const AUTH_URL = process.env.AUTH_URL + '/api';
export const LOGOUT_URL = process.env.AUTH_URL + '/.auth/logout';